import { render, staticRenderFns } from "./multipule-request.vue?vue&type=template&id=0a5fb4d8&scoped=true"
import script from "./multipule-request.vue?vue&type=script&lang=js"
export * from "./multipule-request.vue?vue&type=script&lang=js"
import style0 from "./multipule-request.vue?vue&type=style&index=0&id=0a5fb4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5fb4d8",
  null
  
)

export default component.exports